import { render } from "./RegistrationConfirm.vue?vue&type=template&id=5c2c4555"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__